import { render, staticRenderFns } from "./RequestAccess.vue?vue&type=template&id=a697cde8&scoped=true"
import script from "./RequestAccess.vue?vue&type=script&lang=js"
export * from "./RequestAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a697cde8",
  null
  
)

export default component.exports